export default function Panel({ children, title }) {
    return (
        <div className="bg-white rounded-lg lg:w-1/3 w-11/12 content-center p-12">
            {title && <h1 className="text-center text-general-100 text-4xl font-bold pb-2">{title}</h1>}
            {children}
        </div>
    );
}